import moment from 'moment';
export const catchFunction = (error: any) => {
    if (error?.message === 'canceled') {
        return 0;
    } else if (error?.response?.data?.message?.startsWith('code')) {
        localStorage.clear();
        window.location.reload();
    }
};

export const getDifference = (differenceBy: any, endDate: string, startDate = new Date()) => {
    const start = moment(startDate);
    const end = moment(endDate);
    return start.diff(end, differenceBy);
};

export const redirrect = (imageLink: string) => {
    const setUrl = () => {
        if (!imageLink.startsWith('https')) {
            if (imageLink.startsWith('http')) return imageLink;
            return `https://${imageLink}`;
        }
        return imageLink;
    };
    // // (setUrl());
    const newWindow = window.open(setUrl(), '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
};

export const getAvatar = (name = 'Dr Salim') => {
    const nameToArray = name.split(' ');
    let result = '';
    nameToArray.map((el) => (result += el.charAt(0)));
    // console.log(result);
    return result;
};

let globalCssModule: any;

export function setGlobalCssModule(cssModule: any) {
    globalCssModule = cssModule;
}
export function mapToCssModules(className = '', cssModule = globalCssModule) {
    if (!cssModule) return className;
    return className
        .split(' ')
        .map((c) => cssModule[c] || c)
        .join(' ');
}
